import { Link, SelectField } from '@flos/react-ui';
import { type OptionProps } from '@flos/react-ui/build/core/forms/select/select-input';
import type { OPCTermDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { useHippoText } from '../../../../hooks/useHippoText';
import { useState } from 'react';
import {
    ACC_INJURY_TOOTH_DAMAGE_DEGREE_TERM,
    ACC_INJURY_TOOTH_DAMAGE_FIVE_PERCENT
} from '../../../../constants/term';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { infoModalVariantOpcAtom } from '../../../../recoil/atoms/infoModalVariantOpcAtom';
import { type InformationModalVariant } from '../../../../recoil/types/opcTypes';
import { callMeVariantOpcAtom } from '../../../../recoil/atoms/callMeVariantOpcAtom';
import { isOpcFetchingAtom } from '../../../../recoil/atoms/isOpcFetchingAtom';

const AdjustInjuryDegree = ({
    termInfo,
    updateTermValue
}: {
    termInfo: OPCTermDTO;
    updateTermValue: (termValue: number) => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const setInformationModalVariant = useSetRecoilState(infoModalVariantOpcAtom);
    const setCallMeVariantOpc = useSetRecoilState(callMeVariantOpcAtom);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const [informatioModalDescription, setInformatioModalDescription] = useState(
        'adultAccInjuryDegreeFivePercent'
    );
    const options: OptionProps[] = termInfo.options?.map((option) => ({
        label: `${String(option.code)} %`,
        value: option.code
    })) as OptionProps[];
    const isToothDamageInjuryDegreeTerm = termInfo.publicId === ACC_INJURY_TOOTH_DAMAGE_DEGREE_TERM;

    const onInjuryDegreeChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const selectedIndex = event.target.selectedIndex;
        const { value } = event.target.options[selectedIndex];
        const chosenInjuryDegree = Number(value);

        if (isToothDamageInjuryDegreeTerm && Number(termInfo.value) < chosenInjuryDegree) {
            setCallMeVariantOpc('injuryDegree');
            return;
        }

        updateTermValue(chosenInjuryDegree);
        setInformatioModalDescription(
            value === String(ACC_INJURY_TOOTH_DAMAGE_FIVE_PERCENT)
                ? 'adultAccInjuryDegreeFivePercent'
                : 'adultAccInjuryDegreeEightPercent'
        );
    };

    return (
        <>
            <h6>{getHippoText('DSS-COVERABLE-DETAILS-INJURY-DEGREE-SUBHEADER')}</h6>
            <SelectField
                label={getHippoText('DSS-COVERABLE-DETAILS-INJURY-DEGREE-DROPDOWN')}
                options={options}
                placeholder={`${String(termInfo.value)} %`}
                onChange={onInjuryDegreeChange}
                disabled={isOpcFetching}
            />
            <div className="flos-field">
                <Link
                    onClick={() => {
                        setInformationModalVariant(
                            informatioModalDescription as InformationModalVariant
                        );
                    }}
                    className="u-color-primary-2-base"
                >
                    {getHippoText('DSS-COVERABLE-DETAILS-INJURY-DEGREE-INFO-MODAL')}
                </Link>
            </div>
        </>
    );
};

export default AdjustInjuryDegree;
